import { UserRole } from '@modules/core/types';
import { Permissions } from '@modules/permissions/types';

const commonPermissions = [
  Permissions.STUDY_INSIGHTS__RECRUITMENT_LAYOUT_3,
  Permissions.CDC_TIER1_METRICS,
  Permissions.CAMPAIGN_TRACKING,
];

export const HELIX_WAKEMED_STAGING = {
  [UserRole.ADMINISTRATOR]: [...commonPermissions, Permissions.GENETIC_COUNSELING, Permissions.CAN_VIEW_PHI],
  [UserRole.EXECUTIVE]: commonPermissions,
  [UserRole.MEMBER_LIMITED_PHI]: commonPermissions,
  [UserRole.MEMBER]: [Permissions.GENETIC_COUNSELING, ...commonPermissions, Permissions.CAN_VIEW_PHI],
};
